<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-12-17 13:35:34
 * @LastEditTime: 2026-06-10 13:49:25
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\dialog\priceMaintenance_sign.vue
-->
<!--
 * @Description: 原物料运输结算审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-21 16:54:22
-->
<template>
    <div class="flows-content">
        <el-container>
            <el-main style="margin-bottom: 20px; padding: 0;">
                <el-container direction="vertical">
                    <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
                        @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
                        @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
                        @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
                    <el-main class="info">
                        <div>
                            <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                                placeholder="请输入流程标题"></el-input>
                        </div>
                        <div class="info-top">
                            <div class="left">
                                <span>单据号码：{{ billCode }}</span>
                                <span class="text">制单日期：{{ billDate }}</span>
                            </div>
                            <div class="right">
                                <span>发起人：{{ applyPerson }}</span>
                                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
                            </div>
                        </div>
                        <div class="bill_top">
                            <span><span class="text">工程名称：</span>{{ dialog1Low.name }}<span style="margin-left:24px">生效时间:{{dialog1Low.effectiveTime}}</span><span style="margin-left:24px">价格类型:  {{ ["", "产品价格", "协商价格", "信息价格", "特殊价格"][dialog1Low.priceType * 1] }}</span></span>
                        </div>
                        <el-button size="mini" class="bottom_all" style="margin-left: 12px"
                                @click="lookDialog1">查看调价</el-button>
                        <div class="flows-details">
                            <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible"
                                @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish"
                                @handleBusiness="handleBusiness" @resetFlowState="resetFlowState" />
                        </div>
                    </el-main>
                    <!-- 工程调价 -->
                    <diaLog1 :dialog="dialog1" :isLook="true" :low="dialog1Low" @reset="reset"></diaLog1>
                </el-container>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { updateStatus } from "@/api/internetSales/engineeringControl.js";
const diaLog1 = () => import("@/views/platform/ICPS/internetSales/dialog/engineeringControl1");
export default {
    components: {
        FlowContent,
        FlowHeader,
        diaLog1
    },
    data() {
        return {
            type: 0,
            title: '工程调价审批',
            billCode: '',
            billDate: '',
            applyPerson: '',
            taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
            taskStatus: 0,
            readOnly: false,
            showSendVisible: false,
            billData: {
                productSummarys: [],
                differSummarys: [],
                pumpSummarys: [],
                additional: [],
                smallVolumeSummarys: [],
                totalList: [],
                deadlineDate: "",
            },
            additional: [],
            low: {},
            totalList1: [
            ],
            dataType: "",
            priceMaintenanceDig: true,
            dialog1: false,
            dialog1Low: {
                id: "",
            }
        }
    },
    methods: {
        reset(key) {
            this[key] = false;
        },
        lookDialog1() {
            this.dialog1 = true
        },
        //不同意回调
        resetFlowState() {
            this.handleBusiness()
        },
        combined(arr, item) {
            let num = 0
            arr.forEach(res => {
                num = Number(res[item]) + num
            })
            return num.toFixed(2)
        },
        handleBusiness() {
            const params = {
                process_success: {
                    url: '/icps/system/sign/cloudSell/productCost/updateStatus',
                    data: {
                        id: this.dialog1Low.readjustPricesResordId,//调价记录id
                        sureMaintain: 1//1审核通过；3审核失败
                    },
                    httpMethod: 'post',
                },
                process_failure: {
                    url: '/icps/system/sign/cloudSell/productCost/updateStatus',
                    data: {
                        id: this.dialog1Low.readjustPricesResordId,//调价记录id
                        sureMaintain: 3//1审核通过；3审核失败
                    },
                    httpMethod: 'post',
                }
            }
            this.showSendVisible = false;
            this.$refs.flowcontent.handleToFlow(params);
        },
        /**
         * @Description: 
         * @Param: 1为保存，2为最后提交
         * @Author: wangwangwang
         * @param {*} type
         */
        handleFinish(type) {
            if (type == 1) {
                updateStatus({
                    id: this.dialog1Low.readjustPricesResordId,
                    sureMaintain: 2,
                }).then(() => {
                })
                return
            }
        },
        handleSubmit(type) {
            const { query } = this.$route;
            if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
                this.showSendVisible = true;
                return
            }
            const data = {
                dataSource: 'priceMaintenance_sign',
                dataContent: JSON.stringify(this.dialog1Low), // 业务数据
            }
            this.$refs.flowcontent.saveFlows(type, data);
        },
        handleFlowChat() {
            this.$refs.flowcontent.showFlowNode()
        },
        handleCancel() {
            this.showSendVisible = false;
        },
        initFlowsData() {
            const { query } = this.$route;
            if (query.type * 1 !== 1) {
                this.title = this.dialog1Low.name + query.taskName;
            }
            this.billCode = query.receiptNumber;
            this.billDate = query.createTime;
        },
        sendCode(code) {
            this.billCode = code;
        },
    },
    created() {
        const { query } = this.$route;
        this.titlestatus = Number(query.type)
        this.dialog1Low.id = JSON.parse(query.dataContent).id
        this.dialog1Low.name = JSON.parse(query.dataContent).name
        this.dialog1Low.readjustPricesResordId = JSON.parse(query.dataContent).readjustPricesResordId
        this.dialog1Low.priceType = JSON.parse(query.dataContent).priceType
        this.dialog1Low.effectiveTime = JSON.parse(query.dataContent).effectiveTime
        // this.additional = this.additional.map(item => [item])
    },
    mounted() {
        const { query } = this.$route;

        // this.additional = ['细石', '测试']
        if (query.type * 1 === 1) { // 发起流程
            this.$refs.flowcontent.initBaseData('priceMaintenance_sign');
            this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
            this.applyPerson = getUserInfo().userRealName;
            return
        }
        this.initFlowsData()
        this.applyPerson = query.createUserName;
        this.taskStatus = query.taskStatus;
        if (query.isReadOnly * 1 === 1) {
            this.readOnly = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.bill_top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 40px;
    font-size: 18px;

    .text {
        font-weight: 600;
        color: #000;
    }
}

.bill_title {
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0;
}

.bill_title1 {
    font-size: 18px;
    font-weight: 600;
    padding: 20px 0;
}

.bill_subtitle {
    padding: 20px 0;

    >span {
        padding-right: 20px;
    }

    .text {
        color: #000;
    }
}

.combined {
    border: 1px solid #ebeef5;
    text-align: center;
    line-height: 40px;
}

.flows-details {
    margin-top: 20px;
}

.info {
    padding: 0 20px;
    background: #fff;

    .info-top {
        font-size: $font_size;
        color: #000000;
        @include discen_al;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px #e1e5ed solid;

        .left {
            @include discen_al;
        }

        .text {
            margin-left: 60px;
        }
    }
}

.nav_title {
    @include discen_al;
    align-items: flex-end;

    >div {
        width: 4px;
        height: 24px;
        background: $bg_color;
        margin-right: 10px;
    }

    i {
        margin-left: 5px;
    }

    color: $bg_color;
    font-size: 20px;
    font-weight: bold;
}

.dialoginfo {
    padding: 0;
}

.active {
    border-top: 1px #e1e5ed solid;
    border-right: 1px #e1e5ed solid;
    border-left: 1px #e1e5ed solid;
    background: #fff;
}

.dialoginfo-info {
    border-right: 1px #e1e5ed solid;
    border-left: 1px #e1e5ed solid;
    border-bottom: 1px #e1e5ed solid;
}

/*弹窗*/
.dialoginfo-title {
    >div {
        cursor: pointer;
    }

    height: 48px;
    display: flex;
    background: linear-gradient(180deg,
        rgba(250, 252, 255, 1) 0%,
        rgba(245, 247, 250, 1) 100%);

    .none {
        font-weight: bold;
        height: 48px;
        @include discen;
        width: calc(calc(100% - 1px) / 2);
        border-bottom: 1px solid #e1e5ed;

        >div {
            line-height: 48px;
            border-bottom: 1px rgba(0, 0, 0, 0) solid;
        }
    }

    .center {
        width: 1px;
        height: 48px;
        background: #e1e5ed;
    }

    .active {
        font-weight: bold;
        height: 48px;
        @include discen;
        width: calc(calc(100% - 1px) / 2);
        border-bottom: 1px solid rgba(0, 0, 0, 0);

        >div {
            color: $bg_color;
            line-height: 48px;
            border-bottom: 1px $bg_color solid;
        }
    }
}

.dialoginfo-info {
    padding: 10px 20px;
    overflow: auto;
    height: calc(85vh - 282px);

    .el-select,
    .el-input,
    .el-date-picker {
        width: 100%;
    }
}

.form-title {
    font-size: 18px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
}
</style>